export default __webpack_public_path__ + "static/media/ic_award.03e4a59d.svg";